import {transitionBarrier} from "./animation";

export function stickyBar(el) {
    let button, list;
    try {
        ({ button, list } = findElements(el));
    } catch (e) {
        console.error("Error initializing sticky bar:", e);
        return;
    }

    let open = false;
    let transition = false;

    button.addEventListener("click", async () => {
        if (transition) {
            return;
        }

        transition = true;
        if (!open) {
            await openList(list);
            open = true;
        } else {
            await closeList(list);
            open = false;
        }
        transition = false;
    });
}

async function openList(list) {
    list.style.transition = "transform 300ms ease";
    list.style.transform = "scaleY(1)";

    await transitionBarrier(list);

    list.style.transition = "";
}

async function closeList(list) {
    list.style.transition = "transform 300ms ease";
    list.style.transform = "scaleY(0)";

    await transitionBarrier(list);

    list.style.transition = "";
    list.style.transform = "";
}

function findElements(el) {
    const button = el.querySelector("button");
    if (!button) {
        throw new Error("button not found");
    }

    const list = el.querySelector("ul");
    if (!list) {
        throw new Error("list not found");
    }

    return { button, list };
}